<ng-container *ngIf="rangeMode; else singleMode">
	<mat-date-range-input
		[formGroup]="rangeGroup"
		[rangePicker]="dtPicker"
		[min]="input?.min"
		[max]="input?.max"
		[dateFilter]="input?.matDatepickerFilter"
		[disabled]="input?.disabled"
		class="sat-compat-hidden"
	>
		<input matStartDate formControlName="start" />
		<input matEndDate formControlName="end" />
	</mat-date-range-input>
	<mat-date-range-picker #dtPicker (opened)="onPickerOpened()" (closed)="onPickerClosed()"></mat-date-range-picker>
</ng-container>

<ng-template #singleMode>
	<input
		matInput
		[matDatepicker]="singlePicker"
		[formControl]="singleControl"
		[min]="input?.min"
		[max]="input?.max"
		[matDatepickerFilter]="input?.matDatepickerFilter"
		[disabled]="input?.disabled"
		class="sat-compat-hidden"
	/>
	<mat-datepicker #singlePicker (opened)="onPickerOpened()" (closed)="onPickerClosed()"></mat-datepicker>
</ng-template>
